var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "express-stop",
    transform: "translate(-4011 -6788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "express-stop-2",
    "data-name": "express-stop",
    transform: "translate(-182 155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "android-stop",
    transform: "translate(4193.002 6632.833)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#9d9fa1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#9d9fa1",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "website",
    transform: "translate(4026.286 6804.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M83.909,199.677a1.718,1.718,0,0,1-.439,1.043,1.664,1.664,0,0,1-1.053.434H69.291a1.484,1.484,0,0,1-1.491-1.472V189.7H83.909V196A18.154,18.154,0,0,1,83.909,199.677Z",
    transform: "translate(-64.495 -180.454)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M52.189,53H35.549A2.535,2.535,0,0,0,33,55.515v13.92a3.381,3.381,0,0,0,3.4,3.353H51.341a3.381,3.381,0,0,0,3.4-3.353.848.848,0,0,0-1.7,0,1.687,1.687,0,0,1-1.7,1.677H36.4a1.687,1.687,0,0,1-1.7-1.677V58.074H53.042v7.17a.848.848,0,0,0,1.7,0V55.515A2.535,2.535,0,0,0,52.189,53Zm-3.436,1.677a.838.838,0,1,1-.848.838A.844.844,0,0,1,48.753,54.677ZM53,55.515a.848.848,0,1,1-.848-.838A.844.844,0,0,1,53,55.515Zm-18.3,0a.844.844,0,0,1,.848-.838h10.8A2.488,2.488,0,0,0,46.36,56.4H34.7Z",
    transform: "translate(-31.392 -50.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M4.609-3.031A2.045,2.045,0,0,0,2.379-5.04,2.056,2.056,0,0,0,.171-2.981,2.07,2.07,0,0,0,2.379-.908,2.094,2.094,0,0,0,4.517-2.376h-1.5a.7.7,0,0,1-.634.3.652.652,0,0,1-.685-.563H4.574A2.5,2.5,0,0,0,4.609-3.031Zm-2.23-.848a.644.644,0,0,1,.685.506H1.708A.642.642,0,0,1,2.379-3.879ZM9.04-1.051,7.791-3.086,8.934-4.9H7.217l-.484.853L6.248-4.9H4.531L5.677-3.081l-1.26,2.03H6.184L6.732-2.09l.549,1.039Z",
    transform: "translate(5.505 19.256)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.6aaaf81a5172553b41b24367e89f215b.svg";
export { ForwardRef as ReactComponent };